module.exports = __webpack_public_path__ + "static/media/dialer_1.64494df0.ico";